import { createFileRoute } from '@tanstack/react-router';
import { GrantsPage } from '@pages/grants';

export const Route = createFileRoute('/_shell/')({ component: GrantsPage });
